import { useEffect } from 'react';

export const parentHasClass = (element: HTMLElement, classNames: Array<string>): boolean => {

    for (const className of classNames) {
        if (element.classList && element.classList.contains(className)) {
            return true;
        }
    }

    return Boolean(element.parentElement && parentHasClass(element.parentElement, classNames));
};

const useOnClickOutside = (
    refElement: HTMLElement | null,
    handler: (event: MouseEvent | TouchEvent) => void,
    skipClickClasses: Array<string> = [ 'skip-click' ]
) => {

    useEffect(() => {
        if (refElement) {
            const listener = (event: MouseEvent | TouchEvent) => {
                const target = event.target as HTMLElement;

                // Do nothing if clicking ref's element or descendent elements
                if (refElement.contains(target)) {
                    return;
                }

                const targetClasses = Array.from(target.classList);

                // target's classes check for cases when target is already out of DOM
                if (
                    parentHasClass(target, skipClickClasses) ||
                    targetClasses.find(targetClass =>  skipClickClasses.includes(targetClass))
                ) {
                    return;
                }

                handler(event);
            };

            document.addEventListener('mousedown', listener);
            document.addEventListener('touchstart', listener);

            return () => {
                document.removeEventListener('mousedown', listener);
                document.removeEventListener('touchstart', listener);
            };
        }
    }, [ refElement, handler ]);
};

export default useOnClickOutside;
